import { SUPPORTED_LOCALES_OBJ } from '@zep-us/i18n';
import { type GetStaticPropsContext } from 'next';
import { NoSSR } from '@/components';
import { getBuildLayout } from '@/layout/getBuildLayout';
import { getDefaultStaticProps } from '@/utils/next';
import { BuildPageView } from '../views/build';
const BuildPage = () => {
  return <NoSSR data-sentry-element="NoSSR" data-sentry-component="BuildPage" data-sentry-source-file="build.page.tsx">
      <BuildPageView isUpdate={false} data-sentry-element="BuildPageView" data-sentry-source-file="build.page.tsx" />
    </NoSSR>;
};
BuildPage.getLayout = getBuildLayout;

// Guest access allowed - auth handled in BuildPageView
export default BuildPage;
export const getStaticProps = async ({
  locale = SUPPORTED_LOCALES_OBJ.en
}: GetStaticPropsContext) => {
  return getDefaultStaticProps({
    locale,
    namespaces: ['build', 'common', 'aiTutorTemplates']
  });
};